if (!customElements.get('ebike-key-features')) {
  customElements.define('ebike-key-features', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-ebike-features-open]');
      if (!this.dialog || !this.trigger) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelectorAll('[data-ebike-features-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded', 'false');
        if (!this.skipRestoreFocus) this.trigger.focus({ preventScroll: true });
        this.skipRestoreFocus = false;
      }, options);
      this.querySelector('[data-ebike-features-specs]')?.addEventListener('click', event => {
        const tab = Array.from(document.querySelectorAll('[role="tab"]')).find(element => /^technical specifications?$/i.test(element.textContent.trim()));
        if (!tab) return;
        event.preventDefault();
        this.skipRestoreFocus = true;
        this.dialog.close();
        requestAnimationFrame(() => {
          tab.click();
          tab.focus({ preventScroll: true });
          const target = tab.closest('[role="tablist"]') || tab;
          target.classList.add('ebike-key-features__specs-target');
          target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
      this.controller?.abort();
      this.controller = null;
    }
  });
}
